import { AIMessage } from './types'

/**
 * The request a suggestion assistant is answering, when the user typed nothing.
 *
 * The wizard can be opened straight from the Add asset dialog, and its two
 * suggestion assistants are still worth asking then — what usually owns a
 * property, how this repository files a fund. But every one of them takes the
 * user's own words as its request, and an empty message is not a question.
 *
 * So the absence is stated rather than sent as a blank: the prompts branch on
 * this line, and answer from the flow and the repository instead of pretending
 * to have read something. The wording is load-bearing — see
 * `ai_tag_suggestion` and `ai_account_type_suggestion`.
 */
export const noSentenceRequest = (flow: string) =>
  `No description given — the user opened the "${flow}" wizard directly and is choosing this themselves.`

export const prepareMessages = (content: string) => {
  const messages: AIMessage[] = []
  const message: AIMessage = {
    role: 'human',
    content,
  }
  messages.push(message)
  return { messages, message }
}
